import React, { ReactElement } from 'react';
import FormModal from '../../../common/form/FormModal';
import ProfessionalExperiencesFormItems from './ProfessionalExperiencesFormItems';

export default ({
    isAddExperiencesModalOpen,
    onSave,
    onClose,
    isSaving,
    title
}: {
    isAddExperiencesModalOpen: boolean;
    onSave: () => void;
    onClose: () => void;
    isSaving: boolean;
    title: string | ReactElement;
}) => {
    return (
        <FormModal
            id={'add-person-professional-experience'}
            title={title}
            isOpen={isAddExperiencesModalOpen}
            onSave={onSave}
            onClose={onClose}
            isSaving={isSaving}
            sx={{ height: { xs: '100%', sm: 'auto' } }}
        >
            <ProfessionalExperiencesFormItems />
        </FormModal>
    );
};
